(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  /* ---------- Gallery ---------- */
  var galMain = $('#galMain'); var thumbs = $$('#thumbs .thumb'); var gi = 0;
  var galVideo = $('#galVideo');
  function stopVideo() { if (galVideo) { galVideo.hidden = true; galVideo.innerHTML = ''; } }
  function setImg(i) {
    if (!thumbs.length || !galMain) return;
    gi = (i + thumbs.length) % thumbs.length;
    var btn = thumbs[gi];
    var type = btn.getAttribute('data-type');
    var full = btn.getAttribute('data-full');
    var video = btn.getAttribute('data-video');
    if (type === 'video' && video && galVideo) {
      galMain.style.display = 'none';
      galVideo.hidden = false;
      galVideo.innerHTML = '<video src="' + video + '" controls playsinline preload="metadata"></video>';
    } else {
      stopVideo();
      galMain.style.display = '';
      if (full) galMain.src = full;
    }
    thumbs.forEach(function (t) { t.classList.remove('active'); }); btn.classList.add('active');
  }
  thumbs.forEach(function (b, i) { b.addEventListener('click', function () { setImg(i); }); });
  var gp = $('#galPrev'), gn = $('#galNext');
  if (gp) gp.addEventListener('click', function () { setImg(gi - 1); });
  if (gn) gn.addEventListener('click', function () { setImg(gi + 1); });
  if (thumbs.length && thumbs[0].getAttribute('data-type') === 'video') setImg(0);

  /* ---------- Variants (multi-option) ---------- */
  var select = $('#variantSelect');
  var allOpts = select ? $$('#variantSelect option') : [];
  var groups = $$('.swatches[data-opt-group]');
  var selected = [];
  groups.forEach(function (g) {
    var idx = parseInt(g.getAttribute('data-opt-group'), 10);
    var act = g.querySelector('.swatch.active') || g.querySelector('.swatch');
    selected[idx] = act ? act.getAttribute('data-value') : null;
  });
  function findOpt() {
    var title = selected.join(' / ');
    return allOpts.filter(function (o) { return o.getAttribute('data-title') === title; })[0];
  }
  function valueFullySold(idx, value) {
    var any = false, avail = false;
    allOpts.forEach(function (o) {
      var parts = (o.getAttribute('data-title') || '').split(' / ');
      if (parts[idx] === value) { any = true; if (o.getAttribute('data-available') !== 'false') avail = true; }
    });
    return any && !avail;
  }
  function setStock(available) {
    var pill = $('#stockPill'), txt = $('#stockText'), add = $('#buyInstant'), sticky = $('#stickyBtn'), payWrap = $('#payWrap');
    if (pill) pill.classList.toggle('sold', !available);
    if (txt) txt.textContent = available ? 'In stock, ready to ship' : 'Currently sold out';
    if (add) { add.disabled = !available; add.classList.toggle('btn-soldout', !available); add.textContent = available ? 'Add to cart' : 'Sold out'; }
    if (sticky) { sticky.disabled = !available; sticky.classList.toggle('btn-soldout', !available); sticky.textContent = available ? 'Add to cart' : 'Sold out'; }
    if (payWrap) payWrap.style.display = available ? '' : 'none';
  }
  function refreshVariant() {
    var o = findOpt(); if (!o || !select) return;
    select.value = o.value;
    var pr = o.getAttribute('data-price'), cmp = o.getAttribute('data-compare');
    var pn = $('#priceNow'); if (pn) pn.textContent = pr;
    var pw = $('#priceWas'), sp = $('#savePill');
    var cmpN = parseFloat((cmp || '').replace(/[^0-9.]/g, '')), prN = parseFloat((pr || '').replace(/[^0-9.]/g, ''));
    if (pw && cmp && cmpN > prN) { pw.textContent = cmp; pw.style.display = ''; if (sp) { sp.textContent = 'Save ' + Math.round((cmpN - prN) / cmpN * 100) + '%'; sp.style.display = ''; } }
    else { if (pw) pw.style.display = 'none'; if (sp) sp.style.display = 'none'; }
    var stk = $('#stickyPrice'); if (stk) stk.textContent = pr;
    setStock(o.getAttribute('data-available') !== 'false');
  }
  function applyFilledRing(g) {
    $$('.swatch.swatch-filled', g).forEach(function (x) {
      if (x.classList.contains('active')) {
        var hex = x.getAttribute('data-hex') || '';
        x.style.boxShadow = hex ? ('0 0 0 3px #fff, 0 0 0 6px ' + hex) : '';
      } else { x.style.boxShadow = ''; }
    });
  }
  groups.forEach(function (g) {
    var idx = parseInt(g.getAttribute('data-opt-group'), 10);
    $$('.swatch', g).forEach(function (s) {
      if (valueFullySold(idx, s.getAttribute('data-value'))) s.classList.add('sold');
      s.addEventListener('click', function () {
        selected[idx] = s.getAttribute('data-value');
        $$('.swatch', g).forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        var lbl = $('.opt-current[data-opt="' + idx + '"]'); if (lbl) lbl.textContent = s.getAttribute('data-value');
        refreshVariant();
        applyFilledRing(g);
      });
    });
    applyFilledRing(g);
  });
  if (select && groups.length) refreshVariant();

  /* ---------- Rectangle color swatches (color + pages, border tint) ---------- */
  var rectSwatches = $$('#rectSwatches .rect-swatch');
  function optForTitle(t) { return select ? [].slice.call(select.options).filter(function (o) { return o.getAttribute('data-title') === t; })[0] : null; }
  rectSwatches.forEach(function (s) {
    s.addEventListener('click', function () {
      var val = s.getAttribute('data-value');
      rectSwatches.forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      var o = optForTitle(val); if (!o || !select) return;
      select.value = o.value;
      var vn = $('#variantName'); if (vn) vn.textContent = val;
      var pr = o.getAttribute('data-price'), cmp = o.getAttribute('data-compare');
      var pn = $('#priceNow'); if (pn) pn.textContent = pr;
      var pw = $('#priceWas'), sp = $('#savePill');
      var cmpN = parseFloat((cmp || '').replace(/[^0-9.]/g, '')), prN = parseFloat((pr || '').replace(/[^0-9.]/g, ''));
      if (pw && cmp && cmpN > prN) { pw.textContent = cmp; pw.style.display = ''; if (sp) { sp.textContent = 'Save ' + Math.round((cmpN - prN) / cmpN * 100) + '%'; sp.style.display = ''; } }
      else { if (pw) pw.style.display = 'none'; if (sp) sp.style.display = 'none'; }
      var stk = $('#stickyPrice'); if (stk) stk.textContent = pr;
      setStock(o.getAttribute('data-available') !== 'false');
    });
  });

  /* ---------- Bundle (pack variant + color notes) ---------- */
  var bundlePick = $('#bundlePick');
  var pack = 1;
  var secondColor = $('#secondColor');
  var color1 = null, color2 = null;
  function setPriceFromCard(card) {
    var pn = $('#priceNow'), pw = $('#priceWas'), sp = $('#savePill'), stk = $('#stickyPrice');
    var pr = card.getAttribute('data-price'), cmp = card.getAttribute('data-compare');
    var cmpN = parseFloat((cmp || '').replace(/[^0-9.]/g, '')), prN = parseFloat((pr || '').replace(/[^0-9.]/g, ''));
    if (pn) pn.textContent = pr;
    if (pw && cmp && cmpN > prN) { pw.textContent = cmp; pw.style.display = ''; if (sp) { sp.textContent = 'Save ' + Math.round((cmpN - prN) / cmpN * 100) + '%'; sp.style.display = ''; } }
    else { if (pw) pw.style.display = 'none'; if (sp) sp.style.display = 'none'; }
    if (stk) stk.textContent = pr;
  }
  function setPack(card) {
    pack = parseInt(card.getAttribute('data-qty'), 10);
    $$('#bundlePick .bpack').forEach(function (b) { b.classList.toggle('active', b === card); });
    if (select) select.value = card.getAttribute('data-vid');
    if (secondColor) secondColor.hidden = pack !== 2;
    var cl = $('#colorLabel'); if (cl) cl.textContent = pack === 2 ? 'First board color' : 'Board color';
    setPriceFromCard(card);
  }
  if (bundlePick) {
    $$('#bundlePick .bpack').forEach(function (b) { b.addEventListener('click', function () { setPack(b); }); });
    var activeCard = $('#bundlePick .bpack.active') || $('#bundlePick .bpack');
    if (activeCard) setPack(activeCard);
  }
  function wireColors(listSel, nameSel, set) {
    var cs = $$(listSel + ' .cswatch');
    if (cs.length) set(cs[0].getAttribute('data-color'));
    cs.forEach(function (s) {
      s.addEventListener('click', function () {
        cs.forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        set(s.getAttribute('data-color'));
        var nm = $(nameSel); if (nm) nm.textContent = s.getAttribute('data-color');
      });
    });
  }
  wireColors('#colors1', '#colorName1', function (v) { color1 = v; });
  wireColors('#colors2', '#colorName2', function (v) { color2 = v; });

  /* ---------- Quantity ---------- */
  var qv = $('#qtyValue'), qin = $('#qtyInput'), qty = 1;
  function setQty(n) { qty = Math.max(1, Math.min(10, n)); if (qv) qv.textContent = qty; if (qin) qin.value = qty; }
  var qm = $('#qtyMinus'), qp = $('#qtyPlus');
  if (qm) qm.addEventListener('click', function () { setQty(qty - 1); });
  if (qp) qp.addEventListener('click', function () { setQty(qty + 1); });

  /* ---------- Toast ---------- */
  var toastTimer; function toast(m) { var t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200); }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cartDrawer'), overlay = $('#drawerOverlay');
  function openD() { if (!drawer) return; drawer.classList.add('open'); if (overlay) overlay.classList.add('show'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeD() { if (!drawer) return; drawer.classList.remove('open'); if (overlay) overlay.classList.remove('show'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function render(cart) {
    var cc = $('#cartCount'); if (cc) { cc.textContent = cart.item_count; cc.style.display = cart.item_count > 0 ? 'grid' : 'none'; }
    var items = $('#cartItems'), empty = $('#cartEmpty'), foot = $('#drawerFoot'), tot = $('#cartTotal');
    if (!items) return;
    if (cart.item_count === 0) { items.innerHTML = ''; if (empty) empty.style.display = ''; if (foot) foot.hidden = true; return; }
    if (empty) empty.style.display = 'none'; if (foot) foot.hidden = false;
    if (tot) tot.textContent = money(cart.total_price);
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="' + (it.product_title || '') + '">' : '';
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !it.properties[k]) return;
          props += '<div class="ci-prop">' + k + ': ' + it.properties[k] + '</div>';
        });
      }
      return '<div class="cart-item" data-key="' + it.key + '">' + img +
        '<div class="cart-item-info"><strong>' + it.product_title + '</strong>' +
        '<div class="ci-variant">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '') + 'Qty: ' + it.quantity + '</div>' +
        props +
        '<div class="ci-bottom"><span class="ci-price">' + money(it.final_line_price) + '</span>' +
        '<button class="ci-remove" data-key="' + it.key + '" type="button">Remove</button></div></div></div>';
    }).join('');
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function changeLine(key, q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }

  var cartOpen = $('#cartOpen');
  if (cartOpen && drawer) cartOpen.addEventListener('click', function (e) { e.preventDefault(); openD(); fetchCart(); });
  var cartClose = $('#cartClose'); if (cartClose) cartClose.addEventListener('click', closeD);
  if (overlay) overlay.addEventListener('click', closeD);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });
  var checkoutBtn = $('#checkoutBtn'); if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });
  var itemsEl = $('#cartItems');
  if (itemsEl) itemsEl.addEventListener('click', function (e) { var t = e.target; if (t.classList.contains('ci-remove')) changeLine(t.getAttribute('data-key'), 0); });

  /* ---------- Add to cart ---------- */
  var form = $('#productForm');
  function addToCart() {
    if (!window.fetch || !drawer) { if (form) form.submit(); return; }
    var id = select ? select.value : (form.querySelector('[name="id"]') || {}).value;
    var item = { id: id, quantity: qty };
    if (bundlePick) {
      item.quantity = 1;
      item.properties = {};
      if (pack === 2) {
        if (color1) item.properties['Board 1 color'] = color1;
        if (color2) item.properties['Board 2 color'] = color2;
      } else {
        if (color1) item.properties['Color'] = color1;
      }
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { toast('Added to cart 🎉'); return fetchCart(); })
      .then(openD).catch(function () { if (form) form.submit(); });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  var sticky = $('#stickyBtn'); if (sticky) sticky.addEventListener('click', addToCart);

  /* ---------- Sticky bar ---------- */
  var stickyBar = $('#stickyBuy'), buy = $('#buy');
  if (stickyBar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (en) { if (window.innerWidth <= 640) stickyBar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); }); }, { threshold: 0 }).observe(buy);
  }

  /* ---------- Init cart count badge on load ---------- */
  (function () { var c = $('#cartCount'); if (c) { var n = parseInt(c.textContent, 10) || 0; c.style.display = n > 0 ? 'grid' : 'none'; } })();

  /* ---------- Live viewers ---------- */
  var vw = $('#viewersNow');
  if (vw) { var n = 140 + Math.floor(Math.random() * 90); vw.textContent = n; setInterval(function () { n = Math.max(90, n + Math.floor(Math.random() * 11) - 5); vw.textContent = n; }, 7000); }
})();
